//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
} from "../../../helpers/fakebackend_helper";
import { toast } from 'react-toastify';
import { saveAuthUser, clearAuthUser } from "../../../helpers/tokenHelper";
import { PageActionPermission } from "../../../services/pageActionPermission/PageActionPermission";
import { fetchMyPermissions } from "../../permission/thunk";

import { loginSuccess, logoutUserSuccess, apiError, reset_login_flag } from './reducer';

export const loginUser = (user : any, history : any, returnUrl?: string) => async (dispatch : any) => {
    postFakeLogin({
        userName: user.userName,
        password: user.password,
        tenant: user.tenant  // ADDED
    }).then(async (res : any) => {
      if (res) {
        // Lưu với loginTime để track token expiration
        saveAuthUser(res);
        // Nạp quyền (route/menu + button/input) vào Redux global state ngay sau khi có token — xem
        // mục 9, README_SERCURITY.md. Không chặn luồng login nếu API này lỗi (không phải điều kiện
        // đăng nhập thành công); AuthProtected sẽ tự fetch lại vì state.Permission.loaded vẫn false.
        const permissionResult: any = await dispatch(fetchMyPermissions());
        dispatch(loginSuccess(res));
        // Nếu người dùng bị redirect tới /login từ một trang yêu cầu đăng nhập (AuthProtected lưu
        // lại state.from) thì quay lại đúng trang đó. Ngược lại, không còn trỏ cứng "/dashboard" —
        // nhiều role không có quyền xem Dashboard, gây 403 ngay khi vừa đăng nhập — mà trỏ tới trang
        // ĐẦU TIÊN mà quyền của role hiện tại được phép xem (permissionResult.payload.firstAllowedPath,
        // xem slices/permission/thunk.ts). Về /access-denied nếu không có quyền xem trang nào.
        const firstAllowedPath = permissionResult?.payload?.firstAllowedPath;
        history(returnUrl || firstAllowedPath || '/access-denied');
      }
        }).catch((error : any) => {
      const errorMessage = error.message || 'Login Failed';
      // Backend trả 403 Forbidden riêng cho tài khoản Locked (AccountLockedException,
      // identity-service) — phân biệt với 400/401 của các lỗi đăng nhập khác (mục 8.5, READE.md)
      const isAccountLocked = error.status === 403;
      if (!isAccountLocked) {
        toast.error(errorMessage, { autoClose: 3000 });
      }
      console.log("Error:", error);
      // Dispatch serializable error message instead of Error object
      dispatch(apiError({ message: errorMessage, isAccountLocked }));
    });
};

export const logoutUser = () => async (dispatch : any) => {
  try {
    // Xóa auth data bằng helper function
    clearAuthUser();
    PageActionPermission.clear();

    let fireBaseBackend : any = getFirebaseBackend();
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = fireBaseBackend.logout;
      dispatch(logoutUserSuccess(response));
    } else {
      dispatch(logoutUserSuccess(true));
    }

  } catch (error: any) {
    const errorMessage = error?.message || 'Logout failed';
    dispatch(apiError(errorMessage));
  }
};

export const socialLogin = (type : any, history : any, returnUrl?: string) => async (dispatch : any) => {
  try {
    let response;

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend : any = getFirebaseBackend();
      response = fireBaseBackend.socialLoginUser(type);
    }
    //  else {
      //   response = postSocialLogin(data);
      // }

      const socialdata = await response;
    if (socialdata) {
      // Lưu với loginTime để track token expiration
      saveAuthUser(response);
      // Đồng bộ với loginUser() ở trên — không trỏ cứng "/dashboard" (mục 9, README_SERCURITY.md)
      const permissionResult: any = await dispatch(fetchMyPermissions());
      dispatch(loginSuccess(response));
      const firstAllowedPath = permissionResult?.payload?.firstAllowedPath;
      history(returnUrl || firstAllowedPath || '/access-denied');
    }

  } catch (error: any) {
    const errorMessage = error?.message || 'Social login failed';
    dispatch(apiError(errorMessage));
  }
};

export const resetLoginFlag = () => async (dispatch : any) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error: any) {
    const errorMessage = error?.message || 'Reset login flag failed';
    dispatch(apiError(errorMessage));
  }
};